var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5833 51.6666V46.4999C33.5833 39.3662 27.8003 33.5833 20.6667 33.5833C13.533 33.5833 7.75 39.3662 7.75 46.4999V51.6666H33.5833ZM33.5833 51.6666H54.25V49.0833C54.25 41.474 48.467 36.1666 41.3333 36.1666C37.6822 36.1666 34.385 37.7824 32.0357 40.3803M28.4167 18.0833C28.4167 22.3635 24.9469 25.8333 20.6667 25.8333C16.3865 25.8333 12.9167 22.3635 12.9167 18.0833C12.9167 13.803 16.3865 10.3333 20.6667 10.3333C24.9469 10.3333 28.4167 13.803 28.4167 18.0833ZM46.5 23.2499C46.5 26.1034 44.1868 28.4166 41.3333 28.4166C38.4799 28.4166 36.1667 26.1034 36.1667 23.2499C36.1667 20.3964 38.4799 18.0833 41.3333 18.0833C44.1868 18.0833 46.5 20.3964 46.5 23.2499Z",
    stroke: "url(#paint0_linear_7321_20328)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7321_20328",
    x1: 7.75,
    y1: 30.9999,
    x2: 54.25,
    y2: 30.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#992FDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D73FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.d2192c4cf5e18dbd24622737b857da0e.svg";
export { ForwardRef as ReactComponent };